import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  Modal,
  Select,
  Checkbox,
  Divider,
} from "antd";
import signinLogo from "../../assets/images/logo-for-logins.png";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import encryptDecrypt from "../../helper/encryptDecrypt";
import PhoneInput from "react-phone-input-2";

const { Content } = Layout;
const { Text } = Typography;

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const { request } = useRequest();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [rememberMe, setRememberMe] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        email: values.email,
        password: values.old_password,
      };

      await request({
        url: apiPath.login, // This should be "gym_owner/login"
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          if (data.status === 200) {
            ShowToast(data.message, Severty.SUCCESS);

            // Store user data and tokens
            if (data.data && data.data.user) {
              const { user } = data.data;
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("accessToken", user.token);
              localStorage.setItem("refresh_token", user.refresh_token);

              // Store credentials if remember me is checked
              if (rememberMe) {
                const encryptedEmail = encryptDecrypt.encryptEmail(
                  values.email
                );
                const encryptedPassword = encryptDecrypt.encryptEmail(
                  values.old_password
                );
                localStorage.setItem("ykmCe2AYEFTHobn", encryptedEmail);
                localStorage.setItem("ouUsippetc8S4Ry", encryptedPassword);
              } else {
                // Clear stored credentials if remember me is unchecked
                localStorage.removeItem("ykmCe2AYEFTHobn");
                localStorage.removeItem("ouUsippetc8S4Ry");
              }
            }

            navigate("/dashboard");
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(
            error.response?.data?.message || "Login failed",
            Severty.ERROR
          );
        },
      });
    } catch (err) {
      ShowToast(err.message || "Login failed", Severty.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // Handle remember me functionality
  const handleRememberMeChange = (checked) => {
    setRememberMe(checked);
  };

  // Load saved credentials on component mount
  useEffect(() => {
    const savedEmail = localStorage.getItem("ykmCe2AYEFTHobn");
    const savedPassword = localStorage.getItem("ouUsippetc8S4Ry");

    if (savedEmail && savedPassword) {
      try {
        const originalEmail = encryptDecrypt.decryptEmail(savedEmail);
        const originalPassword = encryptDecrypt.decryptEmail(savedPassword);

        form.setFieldsValue({
          email: originalEmail,
          old_password: originalPassword,
        });
        setRememberMe(true);
      } catch (error) {
        console.error("Error decrypting saved credentials:", error);
        // Clear invalid stored credentials
        localStorage.removeItem("ykmCe2AYEFTHobn");
        localStorage.removeItem("ouUsippetc8S4Ry");
      }
    }
  }, [form]);

  return (
    <>
      <div className="main-new-login-page-designe-divv">
        <Layout className="layout-default layout-signin">
          <Content className="signin">
            <div className="contant-bg-sign">
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={signinLogo} alt="" />
                </div>
                <Row justify="space-around">
                  <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                    <div className="signup-form">
                      {/* <div className="login_header-mian">
                        <h4>Welcome back</h4>
                        <h5>
                          Sign in to access your GYM - TV Admin Dashboard.
                        </h5>
                      </div> */}

                      <Form
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        layout="vertical"
                        className="sign_in_formm"
                      >
                        <div className="login_header-mian">
                          <h4>Welcome to Fusion Hub web app! </h4>
                        </div>
                        <Form.Item
                          className="username"
                          label="Email Address"
                          name="email"
                          rules={[
                            {
                              type: "email",
                              message: "Please enter a valid email address!",
                            },
                            {
                              max: 255,
                              message:
                                "Email address not more than 255 characters!",
                            },
                            {
                              required: true,
                              message: "Please enter your email!",
                            },
                          ]}
                        >
                          <Input placeholder="Enter Email Address" />
                        </Form.Item>

                        <Form.Item
                          label="Enter Password"
                          name="old_password"
                          rules={[
                            {
                              required: true,
                              message: "Please enter password!",
                            },
                            {
                              pattern: new RegExp(
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
                              ),
                              message:
                                "Password must contain at least 8 characters, one capital letter, one small letter, one digit, and one special character",
                            },
                          ]}
                        >
                          <Input.Password placeholder="Enter Password" />
                        </Form.Item>

                        <Form.Item>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "16px",
                            }}
                          >
                            <Checkbox
                              checked={rememberMe}
                              onChange={(e) =>
                                handleRememberMeChange(e.target.checked)
                              }
                            >
                              Remember me
                            </Checkbox>
                            <span
                              style={{
                                color: "hsl(230, 0%, 61%)",
                                cursor: "pointer",
                              }}
                              onClick={() => navigate("/forgot-password")}
                            >
                              Forgot password?
                            </span>
                          </div>
                        </Form.Item>

                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="fill-button"
                            loading={loading}
                          >
                            {loading ? "Logging in..." : "LOGIN"}
                          </Button>
                        </Form.Item>
                      </Form>
                      <div
                        className="already_have_account"
                        style={{ textAlign: "center", marginTop: "20px" }}
                      >
                        {" "}
                        Don't have an account?{" "}
                        <span
                          style={{
                            color: "#1890ff",
                            cursor: "pointer",
                            fontWeight: "500",
                          }}
                          onClick={() => navigate("/register")}
                        >
                          Sign up
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Content>
        </Layout>
      </div>
    </>
  );
};

export default SignIn;
